import { render, staticRenderFns } from "./PointTag.vue?vue&type=template&id=4eb71b8b&scoped=true"
import script from "./PointTag.vue?vue&type=script&lang=js"
export * from "./PointTag.vue?vue&type=script&lang=js"
import style0 from "./PointTag.vue?vue&type=style&index=0&id=4eb71b8b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb71b8b",
  null
  
)

export default component.exports